import React, { useState } from 'react'

import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import { useQuery } from 'src/hooks'
import authService from '../../services/auth.service'
import LoadingIndicator from 'src/common/components/LoadingIndicator'
import Spacer from 'src/common/components/Spacer'
import { parseJwt } from 'src/heplers'
import Logo from 'src/common/logo'

const OktaRedirectPage = () => {
  const [loading, setLoading] = useState(true)

  const query = useQuery()
  const navigate = useNavigate()

  const prevPage = localStorage.getItem('oktaSSOPrevPage')
  const prevEmail = localStorage.getItem('prevEmail')

  if (!prevEmail) {
    location.href = window.location.href.replace('cyberlift', 'cyberly')
  }

  useEffect(() => {
    authService
      .authorizeOkta(query.get('code'), prevEmail)
      .then(resp => {
        localStorage.removeItem('prevEmail')
        localStorage.removeItem('oktaSSOPrevPage')

        if (prevPage == 'login') {
          const userRole = parseJwt(resp?.accessToken).role
          if (['COMPANY_ADMIN', 'ADMIN'].includes(userRole)) {
            navigate('/')
            return
          } else {
            navigate('/login?error=' + 'Access denied')
          }
        }

        setLoading(false)
        if (prevPage == '/settings/sso') {
          navigate('/settings/sso')
        }
      })
      .catch(err => {
        console.error(err)
        navigate(
          `/${prevPage}?error=${err?.response?.data?.description || 'Something went wrong'}&errorSync=${err?.response?.data?.description || 'Something went wrong'}&errorSyncType=OKTA`
        )
        localStorage.removeItem('oktaSSOPrevPage')
        setLoading(false)
      })
  }, [])

  return (
    <div
      style={{
        width: '100%',
        height: '100vh',
        background: '#ffffff',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        paddingTop: '20px'
      }}
    >
      <Logo />
      <Spacer />
      {loading && <LoadingIndicator />}
      <Spacer />
    </div>
  )
}

export default OktaRedirectPage
